import { ValueRange } from "../../../../base/domain/system";
import { IRangeOfMotionBehavior } from "./IRangeOfMotionBehavior";
import { ManualMuscleTestBehavior } from "./ManualMuscleTestBehavior";

export class RangeOfMotionBehavior implements IRangeOfMotionBehavior {
  constructor(
    public range: ValueRange                                  = new ValueRange(0, 100),
    public manualMuscleTestBahavior: ManualMuscleTestBehavior = new ManualMuscleTestBehavior(),
  ) {
  }

  clone(): RangeOfMotionBehavior {
    return new RangeOfMotionBehavior(this.range.clone(), this.manualMuscleTestBahavior.clone());
  }

  static from(source: IRangeOfMotionBehavior): RangeOfMotionBehavior {
    return new RangeOfMotionBehavior(ValueRange.from(source.range), ManualMuscleTestBehavior.from(source.manualMuscleTestBahavior));
  }

  static to(source: RangeOfMotionBehavior): IRangeOfMotionBehavior {
    return {
      range: ValueRange.to(source.range),
      manualMuscleTestBahavior: ManualMuscleTestBehavior.to(source.manualMuscleTestBahavior),
    };
  }
}
